import { ChangeDetectionStrategy, Component, Inject, Injector } from '@angular/core';
import { ApplicationController } from '@core/application';
import { NavigationService } from '@core/services';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'mir-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent {

  constructor(
    @Inject(Injector) _injector: Injector,
    // keep for DI !
    @Inject(NavigationService) _navigation: NavigationService,
    private controller: ApplicationController
  ) {
    this.controller.initialize();
  }
}
